import React, { useState, useEffect, useRef } from 'react';
import UserProfileDropdown from './UserProfileDropdown';
import { message, Button } from 'antd';
import ChatHistory, { filterTitle } from '../../ChatHistory';
import { CloseOutlined } from '@ant-design/icons';
import { IS_GUIDELINE_GPT, PATH_CUSTOMER_ID } from '../../constants';
import { useTrackEvent } from '../../analytics/useTrackEvent';
import useSyncUrlPathID from 'MortgageGPT/hooks/useSyncUrlPathID';
import { useDispatch } from 'react-redux'
import Share from '../Share';
import AISwitch from 'StrataAl/Switch';

// Arrow icon component for the New button
const ArrowIcon = () => (
    <svg
        width="6.72"
        height="11.31"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6 1L1 6L6 11"
            stroke="#325CEB"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const IframeNav = ({ 
    iframeConfig,
    fromLanding,
    onNewChat,
    chatTitle,
    setIsReceivingAnswer,
    activeIframeSession,
    handleContactClick, 
    handleIframeSigninClick,
    handleIframeSignupClick,
    profile,
    subscriptionInfo,
    chatHistoryRef,
    programs,
    getHistoryList,
    getList,
    showHistory,
    setShowHistory,
    docThreadID,
    threadID,
    showPdf,
    titleEmitter,
    onCloseMask,
    setShowSelfPayUpgradeModal,
    onCheckOut,
    companyPayMode,
    currentBillingStatus,
    portalSessionUrl,
    promoCodeValidity,
    setApplyPromoCode,
    setTriggerType,
    downgradedTime,
    isMobile,
    usage,
    onAIChange,
}) => {
    const dispatch = useDispatch()
    const { onRoutePathReplace } = useSyncUrlPathID()

    const [openChatHistoryDropdown, setOpenChatHistoryDropdown] = useState(false);
    const [showRenewalAlert, setShowRenewalAlert] = useState(localStorage.getItem('close-renewal-alert-' + PATH_CUSTOMER_ID) ? false : true);
    const chatHistoryDropdownRef = useRef(null);
    const { trackHeaderUpgradeClicked } = useTrackEvent();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (chatHistoryDropdownRef.current && !chatHistoryDropdownRef.current.contains(event.target)) {
                setOpenChatHistoryDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    function onCloseItemMask() {
        onCloseMask && onCloseMask();
        handleChatHistoryDropdownClick();
    }

    const handleChatHistoryDropdownClick = () => {
        setOpenChatHistoryDropdown(!openChatHistoryDropdown);
    }
    const handleUpgradeClick = () => {
        if (currentBillingStatus === 'past_due') {
            // window.location.href = portalSessionUrl;
            trackHeaderUpgradeClicked(profile, usage, currentBillingStatus);
            setTriggerType('header-cta');
            setShowSelfPayUpgradeModal(true);
        } else if (currentBillingStatus === 'inactive' && promoCodeValidity === 'valid' && PATH_CUSTOMER_ID === 'successlending') {
            setTriggerType('promo-code-applied');
            setApplyPromoCode(true);
            setShowSelfPayUpgradeModal(true);
        } else {
            trackHeaderUpgradeClicked(profile, usage, currentBillingStatus);
            setTriggerType('header-cta');
            setShowSelfPayUpgradeModal(true);
        }
    }

    const handleUpdatePaymentMethodClick = () => {
        window.location.href = portalSessionUrl;
    }
    return (
        <>
            {showRenewalAlert && currentBillingStatus === 'past_due' && (
                <div class='guideline-iframe-nav-alert'>
                    <div className='w-100'>Subscription ended. Please <span className='guideline-iframe-nav-alert-update' onClick={handleUpdatePaymentMethodClick}>update your payment method</span> to restore your Business plan.</div>
                    <img src="/images/close-icon.svg" alt="Close" onClick={() => {
                        localStorage.setItem('close-renewal-alert-' + PATH_CUSTOMER_ID, true);
                        setShowRenewalAlert(false);
                    }} />
                </div>
            )}
            <div className="guideline-iframe-nav" style={{ 
                borderBottom: isMobile ? "1px solid #EBEBEB" : "",
                background: (showPdf || isMobile) ? 'white' : '#F5F5F5' }
            }>
                {!showPdf ? 
                    <div>
                        <Button
                            className="back-chat-btn"
                            onClick={() => {
                                onRoutePathReplace();
                                dispatch({ type: 'SHOW_PDF', data: true })
                                dispatch({
                                    type: 'CHANGE_PDF',
                                    data: undefined,
                                })
                                onNewChat()
                                setShowHistory(fromLanding ? false : true)
                                setIsReceivingAnswer(false);
                            }}
                            type="outline"
                        >
                            <div className="button-icon">
                                <ArrowIcon />
                            </div>
                            Back
                        </Button>
                        <span className='chat-title-adjuster'>{filterTitle(chatTitle) || 'Chat'}</span>
                    </div> : 
                <div>
                    <a
                        href={iframeConfig?.url || 'https://www.zeitro.com'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="zeitro-logo-link"
                    >
                        <img
                            src={iframeConfig?.logo || '/images/zeitro-logo.svg'}
                            alt="Zeitro Logo"
                            className="zeitro-logo"
                        />
                    </a>
                    <AISwitch value="CLASSIC" onChange={onAIChange} />
                </div>
                
                }
                {!activeIframeSession ? (
                    <div className="nav-right">
                        {/* <div 
                            className="guideline-contact-btn" 
                            onClick={handleContactClick}
                        >
                            <span>Contact</span>
                        </div> */}
                        <div>
                            <button 
                                className="floating-bar-btn guideline-iframe-signin-btn"
                                onClick={handleIframeSigninClick}
                            >
                                Sign in
                            </button>
                        </div>
                        <div>
                            <button 
                                className="floating-bar-btn guideline-iframe-signup-btn" 
                                onClick={handleIframeSignupClick}
                            >
                                Sign up
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="nav-right">
                        {!isMobile && profile?.AccountTier === 'free' && companyPayMode === 'self_pay' && <Button type="primary" className='guideline-iframe-nav-upgrade-btn' onClick={handleUpgradeClick}>Upgrade</Button>}
                        
                        {threadID && IS_GUIDELINE_GPT && <Share threadID={threadID} isMobile={isMobile} />}
                        <div className='iframe-chat-history-dropdown'>
                            <div
                                className='iframe-chat-history-dropdown-trigger'
                                onClick={handleChatHistoryDropdownClick}
                            >
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 8V12L14 14M3.0498 11.0001C3.2739 8.80013 4.30007 6.75968 5.93254 5.26803C7.56501 3.77639 9.6895 2.93795 11.9007 2.9127C14.1119 2.88744 16.255 3.67713 17.9211 5.1311C19.5872 6.58507 20.6597 8.60155 20.934 10.7958C21.2083 12.99 20.6651 15.2085 19.4082 17.0278C18.1512 18.8472 16.2684 20.1401 14.1191 20.6599C11.9697 21.1797 9.70421 20.89 7.7548 19.8461C5.80539 18.8022 4.30853 17.0772 3.5498 15.0001M3.0498 20.0001V15.0001H8.0498" stroke="#586570" stroke-width="2.18182" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                {/* {!isMobile && <div className='iframe-chat-history-dropdown-trigger-text'>History</div>} */}
                            </div>
                            {openChatHistoryDropdown && (
                                <div className='iframe-chat-history-dropdown-menu'>
                                    <div className='iframe-chat-history-dropdown-menu-item'>
                                        <div className='iframe-chat-history-close-button'>
                                            <CloseOutlined onClick={handleChatHistoryDropdownClick} />
                                        </div>
                                        <ChatHistory 
                                            ref={chatHistoryRef}
                                            programs={programs}
                                            isMobile={isMobile}
                                            getHistoryList={getHistoryList}
                                            getList={getList}
                                            onCloseMask={onCloseItemMask}
                                            showHistory={showHistory}
                                            setShowHistory={setShowHistory}
                                            threadID={docThreadID}
                                            showPdf={showPdf}
                                            titleEmitter={titleEmitter}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        {!showPdf ? null : <div className='iframe-profile-dropdown-container'>
                            <UserProfileDropdown 
                                profile={profile}
                                subscriptionInfo={subscriptionInfo}
                                setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                                onCheckOut={onCheckOut}
                                companyPayMode={companyPayMode}
                                currentBillingStatus={currentBillingStatus}
                                portalSessionUrl={portalSessionUrl}
                                promoCodeValidity={promoCodeValidity}
                                setApplyPromoCode={setApplyPromoCode}
                                setTriggerType={setTriggerType}
                                downgradedTime={downgradedTime}
                                isMobile={isMobile}
                            />
                            {profile?.AccountTier === 'paid' && companyPayMode === 'self_pay' && <span className='profile-business-plan-tag'>Business</span>}
                        </div>}
                    </div>
                )}
            </div>
        </>
    );
};

export default IframeNav;